document.addEventListener('DOMContentLoaded', function () {
  class cartProgressCart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.freeProductLogic();
    }

    disconnectedCallback() {}

    freeProductLogic() {
      if (
        Number(this.dataset.cartPurchaseQuantity) >= Number(this.dataset.freeProductQuantityThreshold) &&
        this.getAttribute('data-added-free-product-key') == null
      ) {
        this.addFreeProduct(this.getAttribute('data-free-product-vid'));
      } else if (
        Number(this.dataset.cartPurchaseQuantity) < Number(this.dataset.freeProductQuantityThreshold) &&
        this.getAttribute('data-added-free-product-key') != null
      ) {
        this.updateFreeProduct(this.getAttribute('data-added-free-product-key'), 0);
      }

      if (Number(this.dataset.cartQuantity) - Number(this.dataset.cartPurchaseQuantity) > 1) {
        this.updateFreeProduct(this.getAttribute('data-added-free-product-key'), 1);
      }
    }

    addFreeProduct(variantId) {
      let formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: { _is_free_gift: true },
          },
        ],
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (response.ok) {
            setTimeout(() => {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            }, 500);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    updateFreeProduct(lineItemKey, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineItemKey,
          quantity: quantity,
        }),
      }).then((response) => {
        if (response.ok) {
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }, 500);
        }
      });
    }
  }

  customElements.define('cart-progress-bar', cartProgressCart);
});
